import UgcBuilderComponent from '../Ugc';
import { overrideBuilderModel } from '../utils';
export var overrides = {
  defaultStyles: {
    width: '100%',
    padding: '16px',
    maxWidth: '1728px',
    marginLeft: 'auto',
    marginRight: 'auto',
    backgroundColor: 'rgba(255, 255, 255, 1)'
  },
  inputs: [{
    name: 'curateFilterType',
    type: 'string',
    "enum": ['label', 'productId', 'none'],
    defaultValue: 'none'
  }, {
    name: 'filterText',
    type: 'string',
    defaultValue: null
  }]
};
var SXFUgcBuilderComponent = overrideBuilderModel({
  base: UgcBuilderComponent,
  overrides: overrides
});
export default SXFUgcBuilderComponent;